<template>
    <div>
        <HeadlineContainer headline="Competitions" :breadcrumbs="[{text: 'Competitions'}]">
            <router-link to="/competitions/create" class="btn btn-white">
                <i class="fa fa-plus"></i> Create
            </router-link>
        </HeadlineContainer>

        <div class="container">
            <CompetitionList/>
        </div>
    </div>
</template>

<script>
import CompetitionList from '../../../components/Administration/Competitions/Panels/List'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'

export default {
    components: {CompetitionList, HeadlineContainer}
}
</script>
